var _rect, _g, _text, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzRankedShortlistWallSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 104,
    viewBox: "0 0 360 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz ranked shortlist wall sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 356,
    height: 100,
    rx: 18,
    fill: "#06142A",
    fillOpacity: 0.96,
    stroke: "#5F84AA",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 17,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 20,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 45c1-9 5-13 12-13s11 4 12 13M46 34c7-1 12 2 14 10"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 64,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 820,
    letterSpacing: 4.6
  }, "TALENTLENZ")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 46,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#087CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzRankedShortlistWallSign);
export default __webpack_public_path__ + "static/media/talentlenz-ranked-shortlist-wall-sign.521adced07cd1c68662f35d583d5c9eb.svg";
export { ForwardRef as ReactComponent };